import React from "react";
import "./ProjectStyles.css";
import Carousel from "react-material-ui-carousel";
import { Paper, Button } from "@material-ui/core";
import { projectInfo } from "./ProjectsInfo";
import Project from "./Project";
import Fade from "react-reveal/Fade";
import LightSpeed from "react-reveal/LightSpeed";

function Projects() {
  return (
    <div className="projects">
      <div className="projects__top">
        <LightSpeed left>
          <h1 className="projects__heading">Projects</h1>
          <p className="projects__subheading">My Recent Works</p>
        </LightSpeed>
      </div>
      <div className="project__carousel">
        <Fade top>
          <Carousel>
            {projectInfo.map((project) => (
              <Project
                key={project.id}
                image={project.image}
                projectTitle={project.projectTitle}
                description={project.description}
                tags={project.tags.map((tag) => (
                  <li className="tag__names">{tag}</li>
                ))}
                source={project.source}
                demo={project.demo}
              />
            ))}
          </Carousel>
        </Fade>
      </div>
    </div>
  );
}

export default Projects;
